import { render, staticRenderFns } from "./EmployeeAbilities.vue?vue&type=template&id=05f8a8f2&scoped=true&"
import script from "./EmployeeAbilities.vue?vue&type=script&lang=js&"
export * from "./EmployeeAbilities.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAbilities.vue?vue&type=style&index=0&id=05f8a8f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f8a8f2",
  null
  
)

export default component.exports